import BpkButton from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkCardList from '@skyscanner-internal/backpack-web/bpk-component-card-list';
import {
  ACCESSORY_DESKTOP_TYPES,
  ACCESSORY_MOBILE_TYPES,
  LAYOUTS,
} from '@skyscanner-internal/backpack-web/bpk-component-card-list/src/common-types';

import InventoryCard from '../../InventoryCard';
import { useMBDContext } from '../../common/MBD/useMBDContext';

import type { CardRailWithInventoryCardProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CardRailWithInventoryCardProps';

import STYLES from './CardRailWithInventoryCardV2.module.scss';

const CardRailWithInventoryCardV2 = ({
  cards,
  ctaText,
  ctaUrl,
  subtitle,
  title,
}: CardRailWithInventoryCardProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  if (!cards.length) {
    return null;
  }
  return (
    <div
      className={STYLES.CardRailWithInventoryCardV2}
      data-testid="CardRailWithInventoryCardV2"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <BpkCardList
        title={title}
        description={subtitle}
        cardList={cards.map((card, index: number) => (
          <InventoryCard key={card.title} index={index} {...card} />
        ))}
        layoutDesktop={LAYOUTS.row}
        layoutMobile={LAYOUTS.rail}
        accessoryDesktop={ACCESSORY_DESKTOP_TYPES.pagination}
        accessoryMobile={ACCESSORY_MOBILE_TYPES.button}
        buttonContent={
          <BpkButton
            className={STYLES.callToActionButton}
            rel="nofollow"
            href={ctaUrl}
            data-tracking-element-id={`${rawComponentName}_cta`}
            data-tracking-common-params={buildMBDParam(
              `${rawComponentName}_cta`,
            )}
          >
            {ctaText}
          </BpkButton>
        }
      />
    </div>
  );
};

export default CardRailWithInventoryCardV2;
